<template>
    <v-container class="pa-1">
        <v-btn small class="ma-0" @click="$router.back()" color="info" tile outlined>
            <v-icon>mdi-arrow-left-bold</v-icon> Volver al pasado
        </v-btn>

        <h4 class="text-center">
            Pre visualizacion del contrato., <b>Asegurese de revisar todos los datos</b> antes de proceder a
            generar/descargar
            el contrato.
        </h4>
        <v-divider></v-divider>

        <div v-if="datauri">
            <embed :src="datauri + `#toolbar=0`" width="100%" height="630">
        </div>

        <div>
            <v-row v-if="!loading" class="row justify-center" no-cols-gutters>
                <div class="col-12 col-sm-6 col-lg-4">
                    <v-alert dense text type="info" class="text-center">
                        <v-switch label="Enviar contrato por correo" light v-model="enviar_por_correo" inset></v-switch>
                        <span v-if="enviar_por_correo">Al marcar esta opcion, se le hara llegar al estudiante su
                            contrato al correo proporcionado </span>
                        <p v-if="enviar_por_correo" class="ma-0 pa-0">
                            <small> {{ correo_contrato }} </small> <v-btn small color="orange" @click="dialog = true">
                                <v-icon small>mdi-pencil</v-icon> </v-btn>
                        </p>
                    </v-alert>
                </div>
            </v-row>
        </div>
        <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialog"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar color="primary" dark >Correo del participante</v-toolbar>
            <v-card-text class="pt-4">
              <v-text-field label="Corre Electronico" outlined v-model.trim="correo_contrato" ></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="dialog.value = false" color="green">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

        <v-progress-linear v-if="loading" class="mt-2" indeterminate />
        <div class="mb-14 mt-4 text-center">
            <v-btn class="orange darken-2" :loading="loading" dark @click="descargarContrato()" tile>Descargar
                pdf</v-btn>
        </div>


    </v-container>
</template>

<script>
import xaxios from '@/xaxios';
import axios from 'axios'
import gql from 'graphql-tag';
import { mapState } from 'vuex';
import {
    getinput,
    getCategoriaMaestrante,
    getCategoriaName,
    getMesStr,
    getNacionalidad,
    getNumeroDeci,
    getProgramaTitulo,
    getNumeroName
} from './programa_contrato_data'

export default {
    data() {
        return {
            loading: false,
            datauri: '',
            enviar_por_correo: false,
            correo_contrato:'',
            dialog: false,
            dataInput: {},
        }
    },
    computed: { ...mapState({ programa: (state) => state.programa.value }) },
    methods: {
        async getSede() {
            let idsede = this.$store.state.CARGO.sede.id;
            let sql = gql`query{ getSede(id:${idsede}){id,nombre,direccion, ciudad{nombre}, gerente{firma,datos_personales{id,num_doc,nombres,pri_apellido,seg_apellido, departamento{id, nombre, extension}}} } }`;
            const res = await this.$apollo.query({ query: sql }).then(({ data }) => data.getSede)
            return res;
        },
        async getPrograma(idprograma) {
            let sql = gql`query{ getPrograma(id:${idprograma}){arte,nombre_compuesto,modalidad,universidad{id,nombre},programa_modulos{numero,modulo{nombre,sigla,tipo}},sede{id,nombre,ciudad{nombre}},id,postgrado{nombre,creditaje,carga_horaria,categoria{id, nombre}}}}`;
            const res = await this.$apollo.query({ query: sql }).then(({ data }) => data.getPrograma)
            return res;
        },
        async getPlan(inscripcion_id) {
            let url5 = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${inscripcion_id}/plan-pago`;
            const res = await xaxios.get(url5).then(({ data }) => data.data);
            return res;
        },


        async buildDataContrato(codigo_contrato = null) {
            this.dataInput = {};
            this.loading = true;
            const xinscripcion = JSON.parse(sessionStorage.getItem('xinscrito'));
            let sede = await this.getSede();
            let prog = await this.getPrograma(this.programa.id);
            let plan = await this.getPlan(xinscripcion.id)
            let ge = sede.gerente.datos_personales
            let e = xinscripcion.estudiante;
            if(this.correo_contrato == '')
                this.correo_contrato = xinscripcion.estudiante.email;
            let p = JSON.parse(JSON.stringify(this.programa));
            let date = new Date();
            let dia = date.getDate();
            let mes = date.getMonth();
            let anio = date.getFullYear();
            let mes_str = getMesStr(mes);
            let categoria = getCategoriaName(prog.postgrado.categoria);
            let cate_posg = getCategoriaMaestrante(categoria);
            let prog_titu = getProgramaTitulo(categoria);
            let monto_programa = 0;
            let cuotas = 0;
            const modulos = [];
            const planes = [];
            // if(p.modalidad == "V") p.modalidad = "VIRTUAL";

            // window.console.log('prog',prog);
            window.console.log('plan>>>',plan);

            plan.forEach(p => {
                if (p.concepto_pago_id == 2) {
                    monto_programa += Number(p.total);
                    cuotas += 1;
                }
                // fix string to number :) 
                p.total = Number(p.total)
                p.monto_pagado = Number(p.monto_pagado)
                p.monto_descuento = Number(p.monto_descuento)
                p.monto_regularizado = Number(p.monto_regularizado)
                p.monto_compensacion = Number(p.monto_compensacion)
                p.monto_liquido = Number(p.monto_liquido)
                // 
                let saldo = p.total - (p.monto_pagado + p.monto_descuento + p.monto_regularizado + p.monto_compensacion + p.monto_liquido)
                let fecha = saldo == 0 ? 'CANCELADO' : p.fecha_pago;
                planes.push({ numero: '' + p.nro_cuota, concepto: p.concepto_pago, monto: getNumeroDeci(saldo), fecha: fecha })
            });

            prog.programa_modulos.forEach(x => {
                modulos.push({ numero: '' + x.numero, nombre: x.modulo.nombre })
            })

            const data = {
                codigo_contrato: codigo_contrato ? codigo_contrato.codigo : '-',
                unidad: 'LA ESCUELA DE NEGOCIOS ESAM S.R.L.',
                unidad_domicilio: sede.direccion,
                unidad_representante: ge.nombres + ' ' + ge.pri_apellido + ' ' + ge.seg_apellido,
                unidad_cedula: ge.num_doc + '' + (ge.departamento ? ge.departamento.extension : ''),
                unidad_cedula_expedida: ge.departamento ? ge.departamento.nombre : '-',
                participante: e.nombres + ' ' + e.pri_apellido + ' ' + e.seg_apellido,
                participante_id: e.id,
                participante_nacionalidad: getNacionalidad(e.pais),
                participante_domicilio: e.domicilio,
                participante_zona: '-',
                participante_cedula: e.num_doc + '' + (e.departamento ? e.departamento.extension : ''),
                programa: p.nombre_compuesto,
                programa_monto: getNumeroDeci(monto_programa),
                programa_monto_name: getNumeroName(monto_programa),
                programa_modalidad: p.modalidad,
                programa_categoria: categoria,
                programa_titulacion: prog_titu,
                horas_academicas: '' + prog.postgrado.carga_horaria,
                creditaje: '' + prog.postgrado.creditaje,
                posgraduante: cate_posg,
                modulos_count: '' + p.programa_modulos.length,
                modulos: modulos,
                cantidad_cuotas: '' + cuotas,
                plan: planes,
                representacion: ge.nombres + ' ' + ge.pri_apellido + ' ' + ge.seg_apellido,
                ciudad_firma: sede.ciudad.nombre,
                fecha_dia: '' + dia,
                fecha_mes: mes_str,
                fecha_anio: getNumeroName(anio),
            }
            this.dataInput = data;
            this.getDatosUri(data, codigo_contrato);
        },

        async descargarContrato() {
            const xinscripcion = JSON.parse(sessionStorage.getItem('xinscrito'));
            let input = getinput(xinscripcion, this.dataInput)

            this.loading = true;
            let codigocontra = await xaxios.post(`${process.env.VUE_APP_API_REST}/api/v1/contratos/`, input).then(({ data }) => data.data).catch((e) => e);
            if (codigocontra && codigocontra.codigo) {
                this.buildDataContrato(codigocontra);
            } else {
                const t = codigocontra.response.data.data;
                this.loading = false;
                if (t.includes('Ya existe un contrato para la inscripción')) {
                    this.bajarYagenerado();
                }
                window.alert(t);
            }
        },
        async getDatosUri(d, codigo_contrato) {
            let escapedXjson = JSON.stringify(d).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
            let u = process.env.VUE_APP_CONTRATO; 
            let data = JSON.stringify({ query: `mutation getDataUri{ getDataUri(input:{codigo:"",xjson: "${escapedXjson}"})}`, variables: {} });

            let config = {};
            config.method = 'post';
            config.url = u;
            config.data = data;
            config.headers = { 'Content-Type': 'application/json' };

            const res = await axios.request(config).then(({ data }) => data).catch((e) => e);
            if (res.data && res.data.getDataUri) {
                this.datauri = res.data.getDataUri;

                if (codigo_contrato) {
                    await this.guardarPdfServer(codigo_contrato.contrato_id, this.datauri);
                    const link = document.createElement('a');
                    link.href = this.datauri;
                    link.download = d.participante + '.pdf';
                    link.click();
                }

            } else if (res.errors) {
                const e = res.errors[0].message;
                window.console.log('errr::', e);
                window.alert(e);
            }
            this.loading = false;
        },
        async bajarYagenerado() {
            const xinscripcion = JSON.parse(sessionStorage.getItem('xinscrito'));
            let e = xinscripcion.estudiante;
            let name = e.nombres + ' ' + e.pri_apellido + ' ' + e.seg_apellido
            this.loading = true;
            let contratos = await xaxios.get(`${process.env.VUE_APP_API_REST}/api/v1/contratos/${e.id}/persona`).then(({ data }) => data.data).catch((e) => e);
            let doc = contratos.find(x => x.inscripcion_id == xinscripcion.id)
            if (doc) {
                let contrato = await xaxios.get(`${process.env.VUE_APP_API_REST}/api/v1/contratos/${doc.id}/pdf`).then(({ data }) => data.data).catch((e) => e);
                if (contrato && contrato.response) {
                    // let t = contrato.response.data.data; 
                    // window.console.log('>>>>>contrato',t);
                    await xaxios.delete(`${process.env.VUE_APP_API_REST}/api/v1/contratos/${doc.id}`).then(({ data }) => data.data).catch((e) => e);
                } else {
                    const downloadLink = document.createElement('a');
                    downloadLink.href = contrato;
                    downloadLink.download = 'COPIA-' + name + '.pdf';
                    downloadLink.click();
                }
            }
            this.loading = false;
        },
        async guardarPdfServer(contratoid, datauri) {
            //let enviar_por_correo = false;
            let data = {
                contrato_id: contratoid,
                is_enviar: this.enviar_por_correo,
                correo: this.correo_contrato,
                pdf: datauri,
            };
            const url = `${process.env.VUE_APP_API_REST}/api/v1/contratos/pdf`;
            const res = await xaxios.post(url, data).then(({ data }) => data)
            window.console.log('serverrr', res);

        },
    },
    mounted() {
        this.buildDataContrato();
    }
}
</script>


<!-- 
- en la tabla de modulos, se debe mostrar el modulo cero ?
- en el monto del programa solo se esta sumando el monto de colegiatura
- 
-->